(ns app.front.search-counts
  "Filtered totals for unified search tabs, scoped to the submitted shared search."
  (:require [re-frame.core-instrumented :as rf]))

(defn with-scope [db scope]
  (if (= scope (::scope db))
    db
    (assoc db ::scope scope ::counts {} ::requests {})))

(defn start-request [db tab]
  (if (= :view/search (get-in db [:route/match :data :name]))
    (assoc-in db [::requests tab] {:id (random-uuid) :loading? true})
    db))

(defn response-event [db tab event]
  (if (= :view/search (get-in db [:route/match :data :name]))
    [::response (::scope db) tab (get-in db [::requests tab :id]) event]
    event))

(defn done-event [db tab event]
  (if (= :view/search (get-in db [:route/match :data :name]))
    [::done (::scope db) tab (get-in db [::requests tab :id]) event]
    event))

(defn error-event [db tab]
  (when (= :view/search (get-in db [:route/match :data :name]))
    [::error (::scope db) tab (get-in db [::requests tab :id])]))

(defn current-request? [db scope tab request-id]
  (and (= scope (::scope db))
       (= request-id (get-in db [::requests tab :id]))))

(defn record-count [db scope tab total-count]
  (if (and (= scope (::scope db)) (number? total-count))
    (assoc-in db [::counts tab] total-count)
    db))

(rf/reg-event-fx ::response
  (fn [{:keys [db]} [_ scope tab request-id event status response]]
    (when (current-request? db scope tab request-id)
      {:db       (record-count db scope tab (:total-count response))
       :dispatch (into event [status response])})))

(rf/reg-event-fx ::done
  (fn [{:keys [db]} [_ scope tab request-id event]]
    (when (current-request? db scope tab request-id)
      (cond-> {:db (assoc-in db [::requests tab :loading?] false)}
        event (assoc :dispatch event)))))

(rf/reg-event-fx ::error
  (fn [{:keys [db]} [_ scope tab request-id]]
    (when (current-request? db scope tab request-id)
      {:db       (assoc-in db [::requests tab :loading?] false)
       ;; Supplying :on-error replaces comm's default connection notification.
       :dispatch [:notifications/add :toast :error
                  :error/connection-error-title :error/connection-error-description]})))

(rf/reg-sub ::counts :-> ::counts)
(rf/reg-sub ::requests :-> ::requests)
(rf/reg-sub ::loading?
  :<- [::requests]
  (fn [requests [_ tab]] (get-in requests [tab :loading?])))
